import { makeStyles } from '@mui/styles'

export default makeStyles({
  modalContent: {
    margin: '1.5rem',
    maxHeight: '80vh',
    width: 'initial',
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
  },
})
